export const LOAD_COUNTRIES = 'LOAD_COUNTRIES'
export const LOAD_GENDERS = 'LOAD_GENDERS'
export const LOAD_PIECES = 'LOAD_PIECES'
export const LOAD_AGES = 'LOAD_AGES'

